import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Box } from 'foundations-components/transitional/components/Box';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MobilePopover = ({
  children,
  onOpenChange,
  open,
  title,
  content,
  footer
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [children, open && /*#__PURE__*/_jsxs(Modal, {
    use: "fullscreen",
    "aria-label": title,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        color: "text-core-default",
        children: title
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onOpenChange(false)
      })]
    }), /*#__PURE__*/_jsx(Box, {
      flex: "1 1 auto",
      overflowY: "auto",
      children: content
    }), footer && /*#__PURE__*/_jsx(DialogFooter, {
      children: footer
    })]
  })]
});